
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';

export default function Careers() {
  const navigate = useNavigate();

  const jobPositions = [
    {
      title: '自動車整備士（正社員）',
      requirements: [
        '自動車整備士2級以上',
        '実務経験3年以上',
        '普通自動車免許'
      ],
      salary: '月給 25万円〜35万円',
      benefits: [
        '昇給年1回',
        '賞与年2回',
        '各種社会保険完備',
        '退職金制度',
        '資格取得支援制度'
      ]
    },
    {
      title: '自動車整備士見習い',
      requirements: [
        '普通自動車免許',
        '未経験歓迎',
        'やる気のある方'
      ],
      salary: '月給 20万円〜25万円',
      benefits: [
        '研修制度充実',
        '資格取得全額支援',
        '各種社会保険完備',
        '昇給・昇格制度',
        '先輩によるマンツーマン指導'
      ]
    }
  ];

  const workSchedule = [
    { time: '8:30', activity: '出社・朝礼' },
    { time: '9:00', activity: '車検・点検作業開始' },
    { time: '12:00', activity: '昼休憩' },
    { time: '13:00', activity: '午後の作業開始' },
    { time: '15:00', activity: '休憩' },
    { time: '15:15', activity: '作業再開' },
    { time: '17:30', activity: '作業終了・清掃' },
    { time: '18:00', activity: '退社' }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <Breadcrumb />
      <main className="pt-8">
        {/* Hero Section */}
        <section 
          className="py-24 bg-cover bg-center bg-no-repeat relative"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1920&q=80')`
          }}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              整備士として、<br />技術を磨ける環境があります。
            </h1>
            <p className="text-xl max-w-3xl mx-auto leading-relaxed">
              地域に愛される整備工場で、あなたの技術と経験を活かしませんか？<br />
              充実した研修制度と資格取得支援で、キャリアアップをサポートします。
            </p>
          </div>
        </section>

        {/* Job Positions */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-slate-800 text-center mb-12">募集要項</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {jobPositions.map((job, index) => (
                <div key={index} className="bg-gray-50 p-8 rounded-lg">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">{job.title}</h3>
                  
                  <div className="mb-6">
                    <h4 className="text-lg font-semibold text-slate-800 mb-3">応募資格</h4>
                    <ul className="space-y-2">
                      {job.requirements.map((req, idx) => (
                        <li key={idx} className="flex items-center">
                          <i className="ri-check-line text-orange-500 mr-3"></i>
                          <span className="text-gray-700">{req}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="mb-6">
                    <h4 className="text-lg font-semibold text-slate-800 mb-3">給与</h4>
                    <p className="text-xl font-bold text-orange-600">{job.salary}</p>
                  </div>

                  <div className="mb-6">
                    <h4 className="text-lg font-semibold text-slate-800 mb-3">待遇・福利厚生</h4>
                    <ul className="space-y-2">
                      {job.benefits.map((benefit, idx) => (
                        <li key={idx} className="flex items-center">
                          <i className="ri-check-line text-orange-500 mr-3"></i>
                          <span className="text-gray-700">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Work Schedule */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-slate-800 text-center mb-12">1日の仕事の流れ</h2>
            <div className="max-w-4xl mx-auto">
              <div className="space-y-4">
                {workSchedule.map((item, index) => (
                  <div key={index} className="flex items-center bg-white p-4 rounded-lg shadow-sm">
                    <div className="w-20 text-center">
                      <span className="text-lg font-bold text-orange-600">{item.time}</span>
                    </div>
                    <div className="flex-1 ml-6">
                      <span className="text-gray-800">{item.activity}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-slate-800 text-center mb-12">働く環境・制度</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  icon: 'ri-graduation-cap-line',
                  title: '資格取得支援制度',
                  description: '整備士資格の取得費用を全額会社負担。キャリアアップを全面サポートします。'
                },
                {
                  icon: 'ri-team-line',
                  title: '充実した研修制度',
                  description: '先輩整備士によるマンツーマン指導で、未経験の方も安心してスタートできます。'
                },
                {
                  icon: 'ri-heart-line',
                  title: '働きやすい環境',
                  description: '残業少なめ、有給取得推奨。プライベートとの両立を大切にしています。'
                }
              ].map((benefit, index) => (
                <div key={index} className="text-center p-6">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${benefit.icon} text-3xl text-orange-500`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-slate-800 mb-3">{benefit.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Staff Interview */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-slate-800 text-center mb-12">社員インタビュー</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <img 
                  src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80"
                  alt="社員インタビュー"
                  className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
                />
              </div>
              <div>
                <div className="mb-6">
                  <h3 className="text-xl font-bold text-slate-800 mb-2">整備士 田中さん（入社5年目）</h3>
                  <p className="text-orange-600 font-medium">2級自動車整備士</p>
                </div>
                <div className="space-y-4 text-gray-600 leading-relaxed">
                  <p>
                    「未経験で入社しましたが、先輩方の丁寧な指導のおかげで、
                    今では一人前の整備士として働けるようになりました。」
                  </p>
                  <p>
                    「資格取得の費用を会社が負担してくれるので、
                    スキルアップに集中できる環境が整っています。」
                  </p>
                  <p>
                    「お客様から『ありがとう』と言われた時が一番嬉しく、
                    この仕事にやりがいを感じています。」
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-slate-800 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold mb-4">
              一緒に働く仲間を募集しています
            </h2>
            <p className="text-xl mb-8 text-gray-300 max-w-2xl mx-auto">
              まずはお気軽にご相談ください。<br />
              工場見学も随時受け付けております。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="lg" onClick={() => navigate('/contact')}>
                採用エントリーはこちら
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                className="border-white text-white hover:bg-white hover:text-slate-800"
              >
                <i className="ri-phone-line mr-2"></i>
                0120-000-000
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
